<template>
    <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
        <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px">مدیریت تیکت ها</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px;">
            <v-card>
                <v-card-text>
                    <v-data-table :loading="loadingInvoices" :search="SearchValue" :items="dtData" :headers="dtHeaders">
                        <template v-slot:top>
                            <v-row row wrap>
                                <v-col cols="6">
                                    <v-text-field outlined dense label="جستجو بر اساس شماره تیکت"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field outlined dense label="جستجو بر اساس  کاربر"></v-text-field>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:[`item.t_Code`]="{item}">
                            <v-btn :href="'/manage/requests/tickets/'+item.t_Code" text color="blue">#{{item.t_Code}}</v-btn>
                        </template>
                        <template v-slot:[`item.state`]="{ item }">
                            <v-chip small dark :color="item.t_Status == 1 ? 'orange accent-3':'grey accent 2'">{{item.state}}</v-chip>
                        </template> 
                        <template v-slot:[`item.operation`]="{ item }">
                            <v-btn small v-if="item.state == 1" icon color="green"  @click="AcceptComment(item.id)">تایید</v-btn> &nbsp;
                            <v-btn small icon color="red"  @click="DeleteComment(item.id)">حذف</v-btn>

                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
        </v-layout>
    </div>
    
</template>

<script>
const ApiUrl = require("../../constant/apiurl");
const MSGHNDL = require("../../constant/MessageHandler");

const axios = require('axios');
import JsonExcel from 'vue-json-excel'
import { async } from 'q';
export default {
    components:{
        JsonExcel
    },
    name:"tickets",
    data:()=>({
        dtHeaders:[
            {text:"شماره تیکت",value:"t_Code",sortable:true,align:"right"},
            {text:"کاربر",value:"user.surename",sortable:true,align:"right"},
            {text:"تلفن همراه",value:"user.u_Phone",sortable:true,align:"right"},
            {text:"پست الکترونیکی",value:"user.u_Email",sortable:true,align:"right"},
            {text:"تاریخ / ساعت ",value:"date",sortable:true,align:"right"},
            {text:"وضعیت",value:"state",sortable:true,align:"right"},
            {text:"عملیات",value:"operation",sortable:true,align:"right"},
        ],
        dtData:[],
        Repository:[],
        ExcelFields:{
            'شماره تیکت':'t_Code',
            'کاربر':'user.surename',
            'تلفن همراه':'user.u_Phone',
            'پست الکترونیکی':'user.u_Email',
            'تاریخ / ساعت':'date',
            'وضعیت':'state'
        },
        TicketDialog:false,
        Ticket:[],
        Entity:0,
        RegTicketRespLoading:false,
        ticketResponse:"",
        loadingInvoices:false,
        SearchValue:""
    }),
    created(){
        this.GetTickets();
    },
    methods:{
        async AcceptComment(id)
        {
            let vm = this;
            var url=ApiUrl.AcceptComment+'/'+id;
            await axios.post(url)
                .then( async function (res) {
                    console.log(res);
                    if(res.data.status)
                    {
                       await vm.GetTickets();
                       
                    }
                })
                .catch(function (error) {
                
                console.log(error);
                });
        },    
         async DeleteComment(id)
        {
            let vm = this;
            var url=ApiUrl.DeleteComment+'/'+id;
            await axios.post(url)
                .then( async function (res) {
                    console.log(res);
                    if(res.data.status)
                    {
                       await vm.GetTickets();
                       
                    }
                })
                .catch(function (error) {
                
                console.log(error);
                });
        },
        async LoadTickets()
        {
            let vm = this;
            await axios.post(ApiUrl.Ticket.GetEntity+"/"+vm.Entity)
            .then((res)=>{
                var data = res.data;
                if(data.status)
                {
                    vm.Ticket = data.data;
                }
            })
            .catch((err)=>{console.error(err)});
        },
        async GetTickets()
        {
            let vm = this;
            var url=ApiUrl.Ticket.Get;
            vm.loadingInvoices = true;
            await axios.post(url)
                .then(function (res) {
                    vm.loadingInvoices = false;
                    console.log(res);
              
                    if(res.data.status)
                    {
                       vm.dtData = res.data.data;
                       vm.Repository = res.data.data;
                    }
                })
                .catch(function (error) {
                vm.loadingInvoices = false;
                console.log(error);
                });
        }
    }
}
</script>